<template>
  <b-row class="mb-1 mt-2">
    <b-col md="2 d-flex align-items-center">
      <span class="target-audience-text">Campaign Type</span>
    </b-col>

    <b-col md="10">
      <validation-provider
        #default="{ errors }"
        name="campaign text"
        rules="required"
      >
        <div class="demo-inline-spacing">
          <b-form-radio
            class="mt-0"
            v-model="selectedCampaignType"
            plain
            name="campaignType-radio"
            value="scheduler"
            @change="onChange"
          >
            Scheduler
          </b-form-radio>
          <b-form-radio
            class="mt-0"
            v-model="selectedCampaignType"
            plain
            name="campaignType-radio"
            value="lba"
            @change="onChange"
          >
            LBA
          </b-form-radio>
        </div>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-col>

    <!-- Schedular -->
    <b-col v-if="selectedCampaignType === 'scheduler'" md="12" class="mt-2">
      <b-container>
        <b-row>
          <!-- Date -->
          <b-col md="6">
            <b-form-group label="Start Date" label-for="startdate">
              <b-form-datepicker
                id="startdate"
                v-model="campaignForm.start_date"
                locale="ind"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                :min="min"
                :max="max1"
                placeholder="dd/mm/yyyy"
                @input="minDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="End Date" label-for="enddate">
              <b-form-datepicker
                id="enddate"
                v-model="campaignForm.end_date"
                locale="ind"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                :min="min2"
                placeholder="dd/mm/yyyy"
                @input="endDateChange"
              />
            </b-form-group>
          </b-col>
          <!-- End Date -->
        </b-row>

        <b-row>
          <b-col md="12" class="px-0">
            <b-form-group label="Select Time" label-for="channel">
              <!-- <span>For Table</span> -->
              <validation-provider
                #default="{ errors }"
                name="selectTime"
                rules="selectTimes"
              >
                <b-form-input
                  id="selectTime"
                  v-model="campaignForm.forcasted_price"
                  label="text"
                  :state="errors.length > 0 ? false : null"
                  class="d-none"
                  placeholder="0"
                  disabled="disabled"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <custom-table
                ref="rateCard"
                :items="itemRateCard"
                :field="fieldSchedule"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="px-0">
            <b-container>
              <target-audience />
            </b-container>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
    <!-- End Schedular -->

    <!-- LBA -->
    <b-col v-if="selectedCampaignType === 'lba'" md="12" class="mt-2">
      <b-container>
        <b-row>
          <!-- Date -->
          <b-col md="6">
            <b-form-group label="Start Date" label-for="startdate">
              <b-form-datepicker
                id="startdate"
                v-model="campaignForm.start_date"
                locale="ind"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                :min="min"
                :max="max1"
                placeholder="dd/mm/yyyy"
                @input="minDate"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="End Date" label-for="enddate">
              <b-form-datepicker
                id="enddate"
                v-model="campaignForm.end_date"
                locale="ind"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                :min="min2"
                placeholder="dd/mm/yyyy"
                @input="endDateChange"
              />
            </b-form-group>
          </b-col>
          <!-- End Date -->

          <!-- MAP -->
          <b-container>
            <b-row>
              <b-col md="12">
                <div style="position: absolute;z-index: 999;right: 8px;z-index: 2;">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="mt-1 w-100"
                    @click="activePolyline"
                  >
                    {{ apoly }}
                  </b-button>
                  <br />
                  <b-button
                    variant="primary"
                    size="sm"
                    class="mt-1 w-100"
                    @click="clearPolyline"
                  >
                    Clear Polyline
                  </b-button>
                </div>
                <l-map
                  ref="map"
                  style="height: 186px; width: 100%;border: 1px solid #DCDCE3;border-radius: 8px;z-index: 1;"
                  :zoom="zoom"
                  :center="center"
                  @update:zoom="zoomUpdated"
                  @update:center="centerUpdated"
                  @update:bounds="boundsUpdated"
                  @click="addPolyline"
                >
                  <l-tile-layer :url="url"></l-tile-layer>
                  <!-- <l-draw-toolbar position="topright"></l-draw-toolbar> -->
                  <l-polygon
                    :lat-lngs="polygon.latlngs"
                    :color="polygon.color"
                  ></l-polygon>
                  <!-- <l-circle
                    :lat-lng="circle.center"
                    :radius="circle.radius"
                    :color="circle.color"
                  /> -->
                </l-map>
              </b-col>
            </b-row>
          </b-container>
          <!-- End MAP -->
        </b-row>
      </b-container>

      <!-- <b-container> -->
      <!-- <b-row> -->
      <b-col md="12">
        <!-- <b-container> -->
        <target-audience />
        <!-- </b-container> -->
      </b-col>
      <!-- </b-row> -->
      <!-- </b-container> -->
    </b-col>
    <!-- End LBA -->
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormRadio,
  BFormFile,
  BFormCheckboxGroup,
  BButton,
  BCard,
  BContainer,
} from "bootstrap-vue";
import { ValidationProvider, extend } from "vee-validate";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapMutations } from "vuex";

// Import Map
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LPolygon } from "vue2-leaflet";

// Import Section
import TargetAudience from "@/views/page/campaign/formContents/TargetAudience.vue";
import CustomTable from "@/views/component/CustomTable.vue";

extend("number", (value) => {
  // if (value === '0') return true
  const val = parseInt(value.replace(/\./g, ""), 10);
  if (Number.isInteger(val) || val === 0) return true;
  return "Values must be numeric";
});

extend("selectTimes", (value) => {
  if (value !== 0) return true;
  return "Select time is required";
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormFile,
    BFormRadio,
    BFormCheckboxGroup,
    BCard,
    BContainer,
    ValidationProvider,
    vSelect,
    BButton,
    CustomTable,
    TargetAudience,
    LMap,
    LTileLayer,
    LPolygon,
  },
  data() {
    const minDate = new Date();
    return {
      // State Date
      min: minDate,
      min2: null,
      max1: null,
      // End State Date

      selectedCampaignType: "",

      selectedCapping: "by impression",
      selectedLimiter: "Per Day",
      limiter: [
        { value: "Per Day", text: "Per Day" },
        { value: "Per MSISDN", text: "Per MSISDN" },
      ],
      limiter2: [{ value: "Per Day", text: "Per Day" }],
      internal: false,
      addBudget: "0",
      cappingVal: "",
      fieldSchedule: [],
      show: true,
      default_campaign: 0,

      // MAP
      apoly: "Active Drop Here",
      statusApoly: false,
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 14,
      center: [-6.175268, 106.827844],
      bounds: null,
      polygon: {
        latlngs: [],
        color: "green",
      },
      // END MAP
    };
  },
  computed: {
    ...mapGetters("campaign", {
      campaignForm: "getCampaignForm",
    }),
    ...mapGetters("ratecard", {
      itemRateCard: "getSchedulingItem",
      fieldRateCard: "getSchedulingField",
      fieldRateCard2: "getSchedulingField2",
    }),
  },
  beforeMount() {
    // SET Default Time
    const dateNow = new Date()
    let weekDate = new Date(dateNow)
    weekDate.setDate(weekDate.getDate() + 7)
    this.$store.state.campaign.formCampaign.start_date = this.formatDate(dateNow)
    this.$store.state.campaign.formCampaign.end_date = this.formatDate(weekDate)
    this.getScheduling();
    // END SET Default Time
  },
  mounted() {
    this.minDate();
    // eslint-disable-next-line arrow-parens
    // this.optionsUserPersona.map((x) => {
    //   // eslint-disable-next-line no-param-reassign
    //   x.item_data = `${x.personaName} (${x.rowdata}k)`
    //   return x
    // })
  },
  methods: {
    // ...mapActions('campaign', [
    //   'setForcastedAudience',
    //   'setForcastedAudienceIOH',
    //   'setGetParamsDSV',
    // ]),
    ...mapMutations("campaign", {
      setRateCard: "SET_RATE_CARD",
    }),
    ...mapActions('ratecard', [
      'getScheduling',
    ]),

    onChange() {
      if (this.selectedCampaignType === "scheduler") {
        this.campaignForm.campaigntype.type = "scheduler";
        this.campaignForm.upload_msisdn = null;
      } else if (this.selectedCampaignType === "lba") {
        this.campaignForm.campaigntype.type = "lba";
        this.campaignForm.upload_msisdn = null;
      }
      this.$store.state.campaign.formCampaign.campaigntype.type = this.selectedCampaignType;
    },

    validationFormChannel() {
      // return true
      return new Promise((resolve, reject) => {
        this.$refs.channelRule.validate().then((success) => {
          if (success) {
            this.setSchedule();
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },

    // FORMAT DATE
    formatDate(dateNow) {
      const year = dateNow.getFullYear()
      const month = dateNow.getMonth() + 1
      const date = dateNow.getDate()
      return `${year}-${month}-${date}`
    },
    // END FORMAT DATE

    // Min Date
    minDate() {
      const mindate =
        this.campaignForm.start_date === ""
          ? new Date()
          : new Date(this.campaignForm.start_date);
      this.min2 = mindate;
      this.max1 = this.campaignForm.end_date;
      this.resetRateCard();
      this.$refs.rateCard?.getData();
    },
    // End Min Date

    // Date Change End
    endDateChange(val) {
      this.resetRateCard();
      this.$refs.rateCard?.getData();
      this.max1 = val;
    },
    // End Date Change End
    resetRateCard() {
      // this.$refs.rateCard.resetData();
    },
    setSchedule() {
      this.$refs.rateCard.setSchedule();
    },

    // MAP FUNCTION
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    addPolyline(event) {
      if (this.statusApoly) {
        this.polygon.latlngs.push(event.latlng);
        this.$store.state.campaign.formCampaign.targeting.polygons = this.polygon.latlngs;
      }
    },
    clearPolyline() {
      this.polygon.latlngs = [];
      this.$store.state.campaign.formCampaign.polygons.latlngs = [];
    },
    activePolyline() {
      if (this.statusApoly) {
        this.apoly = "Active Polyline";
        this.statusApoly = false;
      } else {
        this.apoly = "Inactive Polyline";
        this.statusApoly = true;
      }
    },
    // END MAP FUNCTION
  },
};
</script>
<style scoped>
/* SDA AUDIENCE EXPLORATION - Visualization */
.title-SDAAudienceExploration h2 {
  background: #3a3b3c;
  color: white;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}
.radio-visualization input {
  visibility: hidden !important;
}
.radio-visualization label {
  cursor: pointer;
}
.btnTargetAudience {
  background: white !important;
  border: none;
  color: black !important;
  font-weight: bold;
}
.btnTargetAudience:hover {
  box-shadow: none !important;
}
.btnTargetAudience.activeBtn {
  background: #ed1a25 !important;
  color: white !important;
}
/* SDA AUDIENCE EXPLORATION - Visualization */

/* SEGMENT SELECTION & BUSINESS DATA EXPLORATION - Manual */
.title-segmentsSelection,
.title-BusinessDataExploration {
  margin-bottom: 24px;
}
.title-segmentsSelection h2,
.title-BusinessDataExploration h2 {
  background: #c6168d;
  color: white;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}
.lable-segmentsSelection {
  padding: 4px;
  text-align: center;
  border-radius: 4px;
  color: white;
}
.totalSubsSelected {
  margin: 8px 0px;
  margin-bottom: 0 !important;
  padding: 8px 0;
  text-align: center;
  background: #32bcad;
  border-radius: 4px;
}
.totalSubsSelected p {
  margin: 0;
  color: #fff;
}
.titleSubs {
  font-size: 12px;
}
.totalSubs {
  font-weight: bold;
  font-size: 24px;
  padding: 6px 0 2px;
}
/* END SEGMENT SELECTION & BUSINESS DATA EXPLORATION - Manual */

/* CARD TARGET AUDIENCE - Manual */
.card-targetAudience {
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 14px;
  margin-bottom: 12px;
}
.btn-cardTargetAudience {
  background: #32bcad;
  color: #fff;
  width: 50%;
}
/* END CARD TARGET AUDIENCE - Manual  */

/* INTEREST */
.btn-addInterest {
  background: #ffcb05 !important;
  border-color: #ffcb05 !important;
}
.btn-addInterest:hover {
  box-shadow: 0 8px 25px -8px #ffcb05 !important;
}
/* END INTEREST - Manual */

/* MAP - Manual */
.title-map {
  font-weight: 900;
  font-size: 16px;
  line-height: 21px;
  color: #5e5873;
}
.maps {
  position: absolute;
  z-index: 999;
  right: 14px;
  flex-direction: column;
}
.btn-map {
  margin: 4px 0;
  background: white !important;
  color: black !important;
  border: none;
  border-radius: 8px;
}
/* MAP - Manual */
</style>
